module.exports = __webpack_public_path__ + "res/0-img_detail.1fc5a791a8500c065c66cab04adf911b.png";